import { render, staticRenderFns } from "./CancelOrderChart.vue?vue&type=template&id=2cf7e80e"
import script from "./CancelOrderChart.vue?vue&type=script&lang=js"
export * from "./CancelOrderChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports